export const LIST_LIBRARY_REQUEST = 'LIST_LIBRARY_REQUEST'
export const LIST_LIBRARY_SUCCESS = 'LIST_LIBRARY_SUCCESS'
export const LIST_LIBRARY_FAIL = 'LIST_LIBRARY_FAIL'

export const LIST_LIBRARY_SUMMARY_REQUEST = 'LIST_LIBRARY_SUMMARY_REQUEST'
export const LIST_LIBRARY_SUMMARY_SUCCESS = 'LIST_LIBRARY_SUMMARY_SUCCESS'
export const LIST_LIBRARY_SUMMARY_FAIL = 'LIST_LIBRARY_SUMMARY_FAIL'

export const DETAIL_LIBRARY_REQUEST = 'DETAIL_LIBRARY_REQUEST'
export const DETAIL_LIBRARY_SUCCESS = 'DETAIL_LIBRARY_SUCCESS'
export const DETAIL_LIBRARY_FAIL = 'DETAIL_LIBRARY_FAIL'

export const UPDATE_LIBRARY_REQUEST = 'UPDATE_LIBRARY_REQUEST'
export const UPDATE_LIBRARY_SUCCESS = 'UPDATE_LIBRARY_SUCCESS'
export const UPDATE_LIBRARY_FAIL = 'UPDATE_LIBRARY_FAIL'

export const LIST_SUMMARY_GENERATOR_LIBRARY_REQUEST =
  'LIST_SUMMARY_GENERATOR_LIBRARY_REQUEST'
export const LIST_SUMMARY_GENERATOR_LIBRARY_SUCCESS =
  'LIST_SUMMARY_GENERATOR_LIBRARY_SUCCESS'
export const LIST_SUMMARY_GENERATOR_LIBRARY_FAIL =
  'LIST_SUMMARY_GENERATOR_LIBRARY_FAIL'

export const CREATE_SUMMARY_GENERATOR_LIBRARY_REQUEST =
  'CREATE_SUMMARY_GENERATOR_LIBRARY_REQUEST'
export const CREATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS =
  'CREATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS'
export const CREATE_SUMMARY_GENERATOR_LIBRARY_FAIL =
  'CREATE_SUMMARY_GENERATOR_LIBRARY_FAIL'

export const DETAIL_SUMMARY_GENERATOR_LIBRARY_REQUEST =
  'DETAIL_SUMMARY_GENERATOR_LIBRARY_REQUEST'
export const DETAIL_SUMMARY_GENERATOR_LIBRARY_SUCCESS =
  'DETAIL_SUMMARY_GENERATOR_LIBRARY_SUCCESS'
export const DETAIL_SUMMARY_GENERATOR_LIBRARY_FAIL =
  'DETAIL_SUMMARY_GENERATOR_LIBRARY_FAIL'

export const UPDATE_SUMMARY_GENERATOR_LIBRARY_REQUEST =
  'UPDATE_SUMMARY_GENERATOR_LIBRARY_REQUEST'
export const UPDATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS =
  'UPDATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS'
export const UPDATE_SUMMARY_GENERATOR_LIBRARY_FAIL =
  'UPDATE_SUMMARY_GENERATOR_LIBRARY_FAIL'

export const DELETE_SUMMARY_GENERATOR_LIBRARY_REQUEST =
  'DELETE_SUMMARY_GENERATOR_LIBRARY_REQUEST'
export const DELETE_SUMMARY_GENERATOR_LIBRARY_SUCCESS =
  'DELETE_SUMMARY_GENERATOR_LIBRARY_SUCCESS'
export const DELETE_SUMMARY_GENERATOR_LIBRARY_FAIL =
  'DELETE_SUMMARY_GENERATOR_LIBRARY_FAIL'

export const DUPLICATE_SUMMARY_GENERATOR_LIBRARY_REQUEST =
  'DUPLICATE_SUMMARY_GENERATOR_LIBRARY_REQUEST'
export const DUPLICATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS =
  'DUPLICATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS'
export const DUPLICATE_SUMMARY_GENERATOR_LIBRARY_FAIL =
  'DUPLICATE_SUMMARY_GENERATOR_LIBRARY_FAIL'

export const POSITION_SUMMARY_GENERATOR_LIBRARY_REQUEST =
  'POSITION_SUMMARY_GENERATOR_LIBRARY_REQUEST'
export const POSITION_SUMMARY_GENERATOR_LIBRARY_SUCCESS =
  'POSITION_SUMMARY_GENERATOR_LIBRARY_SUCCESS'
export const POSITION_SUMMARY_GENERATOR_LIBRARY_FAIL =
  'POSITION_SUMMARY_GENERATOR_LIBRARY_FAIL'